var classes = {"mainMenu":"Ru7bK","mainNavigationBarWrapper":"vuxGF","showBackgroundRelative":"y2K8q","fixedNav":"xizDn","showSticky":"qoAOZ"};

export { classes as default };
